<div class="page-wrapper" *ngIf="location">
  <!-- Header -->
  <div class="location-header">
    <div class="container">
      <h1>Centre in {{ location.town }}</h1>
      <p>11+ Mock Tests Near You in {{ location.town }}</p>
    </div>
  </div>

  <!-- Breadcrumb -->
  <div class="breadcrumb">
    <div class="container">
      <ul>
        <li><a routerLink="/">Home</a></li>
        <li><a routerLink="/locations">Locations</a></li>
        <li>{{ location.town }}</li>
      </ul>
    </div>
  </div>


  <a [routerLink]="['/11plus-mock-test']" [queryParams]="{ scroll: 'calendar-section' }" class="cta-button cta-pv">Book 11plus Mocks</a>

  <!-- Main Content -->
  <div class="container">
    <div class="main-content">
      <!-- Left Column -->
      <div class="left-column">
        <!-- Centre Information -->
        <div class="card">
          <h2>About Our {{ location.town }} Centre</h2>
          <div class="centre-info">
            <div class="info-item">
              <i class="fas fa-info-circle"></i>
              <div>
                <p>{{ location.description }}</p>
              </div>
            </div>
          </div>
        </div>


         <div class="offers-strip">
  <span class="offers-text">
    Save on 11+ Mock Test Bundles
  </span>
  <button class="offers-claim-btn" [routerLink]="['/offer-free-resources']">
    Claim Offers
  </button>
</div>


        <!-- SCHEDULE -->

         <!-- Mock Test Schedule -->
<div class="card" *ngIf="location?.schedules?.length">
  <h2>11+ Mock Test Schedule (2026)</h2>

  <div class="schedule-section" *ngFor="let section of location.schedules">
    <h3>{{ section.title }}</h3>

    <table class="schedule-table">
      <thead>
        <tr>
          <th>Test</th>
          <th>Date</th>
          <th>Book</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of section.rows">
          <td>{{ row.test }}</td>
          <td>{{ row.date }}</td>
          <td>
        <a [href]="row.link" target="_blank" class="book-btn">
          Book Now
        </a>
      </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


        <!-- Services Available -->
        <div class="card">
          <h2>Services Available in {{ location.town }}</h2>

          


          <div class="services-grid">

            <div class="service-item">
              <i class="fas fa-calendar-check"></i>
              <h3>Mock Tests</h3>
              <p>Focused exam technique and revision strategies for success.</p>
            </div>

            <div class="service-item">
              <i class="fas fa-user"></i>
              <h3>11+ Tution</h3>
              <p>Comprehensive 11+ support across all major subjects.</p>
            </div>

              <div class="service-item">
              <i class="fas fa-book"></i>
              <h3>SATs Tuition</h3>
              <p>Comprehensive SATs support across all major subjects.</p>
            </div>


            <div class="service-item">
              <i class="fas fa-book"></i>
              <h3>GCSE Tuition</h3>
              <p>Comprehensive GCSE support across all major subjects including Maths, English, and Sciences.</p>
            </div>

            <div class="service-item">
              <i class="fas fa-graduation-cap"></i>
              <h3>A-Level Tuition</h3>
              <p>Expert A-Level tutoring to help students achieve top grades and university entry.</p>
            </div>

            <div class="service-item">
              <i class="fas fa-users"></i>
              <h3>1-2-1 & Group Classes</h3>
              <p>Interactive small group sessions for effective collaborative learning & Personalized individual tuition tailored to each student's needs.</p>
            </div>


          
          </div>
        </div>

        <!-- Location Map -->
        <div class="card">
          <h2>Find Us in {{ location.town }}</h2>
          <div class="map-container">
            <iframe 
              [src]="safeMapUrl"
              allowfullscreen 
              loading="lazy">
            </iframe>
          </div>
        </div>

        <!-- Photo Gallery -->
        <!-- <div class="card">
          <h2>Our {{ location.town }} Facilities</h2>
          <div class="photo-gallery">
            <div class="photo-item" *ngFor="let photo of location.photos">
              <img [src]="photo" [alt]="location.town + ' Facility'">
            </div>
          </div>
        </div> -->

        <!-- FAQs -->
        <div class="card">
          <h2>FAQs about GCSE Tuition in {{ location.town }}</h2>
          <div class="faq-list">
            <div 
              class="faq-item" 
              *ngFor="let faq of location.faqs; let i = index"
              [class.active]="isFaqActive(i)">
              <div class="faq-question" (click)="toggleFaq(i)">
                <span>{{ faq.question }}</span>
                <i class="fas fa-chevron-down"></i>
              </div>
              <div class="faq-answer">
                <p>{{ faq.answer }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

     

      <!-- Right Column - Sidebar -->
      <div class="right-column">
        <!-- CTA Box -->
        <div class="cta-box">
          <h3>Book Mock Test</h3>
          <p>Face-2-Face | Online</p>
          <p>Start your child's learning journey with a complimentary assessment session.</p>
          <a [routerLink]="['/11plus-mock-test']" [queryParams]="{ scroll: 'calendar-section' }" class="cta-button">Book 11plus Mocks</a>

            <a routerLink="/offer-free-resources" class="offer-button">Claim Offers</a>
        </div>

        <!-- Contact Info -->
        <div class="card">
          <h2>Contact Us</h2>
          <div class="contact-info-box">
            <div class="contact-item">
              <i class="fas fa-phone"></i>
              <a [href]="'tel:' + location.phone">{{ location.phone }}</a>
            </div>
            <div class="contact-item">
              <i class="fas fa-envelope"></i>
              <a [href]="'mailto:' + location.email">{{ location.email }}</a>
            </div>
            <div class="contact-item">
              <i class="fas fa-map-marker-alt"></i>
              <span>{{ location.address }}, {{ location.town }}</span>
            </div>
          </div>
        </div>

        <!-- Opening Hours -->
        <div class="card">
          <h2>Opening Hours</h2>
          <ul class="hours-list">
            <li *ngFor="let hour of location.openingHours">
              <span class="day">{{ hour.day }}</span>
              <span class="time">{{ hour.time }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>